module.exports = __webpack_public_path__ + "img/AP.246a4476.png";